import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Clip, ClipsContainer } from '@/components/common/giphy-media';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h2>{`Library`}</h2>
    <h3>{`Curated Library`}</h3>
    <p>{`GIPHY has built the Clips library based on all of what we know about how users search for and share GIFs. Users will be able to discover & share Clips that best convey their emotions, reactions, and favorite cultural moments.`}</p>
    <h3>{`Content Partners`}</h3>
    <p>{`GIPHY Clips are official. Gone are the days of searching for unverified and unofficial content, or sitting through long videos to find the exact moment that you’re looking for. GIPHY has the high quality Clips that you want, direct from the verified source. Everyday you’ll find new Clips from the biggest names in Entertainment, Sports, News, Pop Culture and viral moments.`}</p>
    <h3>{`Originals and Artists`}</h3>
    <p>{`GIPHY Studios and GIPHY Artist pioneered the formats of GIFs for communication and expression and stickers for cameras and stories. We are now doing the same for Clips.`}</p>
    <p>{`The GIPHY Team follows the data about how people communicate and what they want to share. We’ve built the foundation of the Clips library on these unique insights.`}</p>
    <ClipsContainer mdxType="ClipsContainer">
  <Clip src="https://giphy.com/embed/lQ0rVUUz9R0v79q2vy/video" height="156px" mdxType="Clip" />
  <Clip src="https://giphy.com/embed/ZwtYhKUzglo0jfJiFj/video" height="156px" mdxType="Clip" />
  <Clip src="https://giphy.com/embed/JjBG6BHXRXnYQm15dQ/video" height="156px" mdxType="Clip" />
    </ClipsContainer>
    <h3>{`Real Time`}</h3>
    <p>{`GIPHY has perfected the art of real-time content creation. Our team works hand-in-hand with the production teams for award shows, sporting events, and TV and movie premieres to identify the most shareable moments as they happen. Those become searchable parts of the Clips Library and Trending Feed within moments.`}</p>
    <p>{`Whether it’s a surprise moment at an award show to a line from a movie trailer that's blowing minds on Twitter — GIPHY Clips is the home to find and share the trending real time moments that is buzzing on the internet.`}</p>
    <h3>{`Diversity and Inclusion`}</h3>
    <p>{`GIPHY is committed to embodying the identities of our diverse, global user base. We are dedicated to elevating marginalized communities with an inclusive library for expression while also providing a platform to be seen, heard, and even create commissioned work. Diversity and Inclusion are foundational to GIPHY, our products and the Clips library.`}</p>
    <h3>{`International`}</h3>
    <p>{`GIPHY is creating and curating Clips for our top non-english language searches - Spanish, Hindi, French, Korean and Portuguese`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      